import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { GenericModal } from '@org/ui';
import { GroupForm } from '../../app/components/forms/group';
import { trpc } from '@org/clients/school';
import { unwrapTrpcData } from '@org/ui';
import { useTranslation } from 'react-i18next';

export const Route = createFileRoute('/groups/$groupId')({
  component: GroupDetailRoute,
});

function GroupDetailRoute() {
  const { groupId } = Route.useParams();
  const navigate = useNavigate({ from: '/groups/$groupId' });
  const utils = trpc.useUtils();
  const { data, isLoading } = trpc.groups.get.useQuery({ id: groupId });
  const group = unwrapTrpcData(data);
  const { t } = useTranslation('admin');

  const handleClose = () => {
    navigate({ to: '/groups', replace: true });
  };

  const handleSubmit = async () => {
    await utils.groups.list.invalidate();
    handleClose();
  };

  return (
    <GenericModal
      show
      onClose={handleClose}
      title={t('groups.list.modal.editTitle')}
      size="xl"
      centered
      body={
        isLoading ? (
          <div className="flex h-40 items-center justify-center text-muted-foreground">
            {t('groups.detail.loading')}
          </div>
        ) : group ? (
          <GroupForm defaultValues={group} onSubmit={handleSubmit} onClose={handleClose} />
        ) : (
          <div className="flex h-40 items-center justify-center text-muted-foreground">
            {t('groups.detail.notFound')}
          </div>
        )
      }
      footer={<></>}
    />
  );
}


